import React from "react";

const RaindropPinnedToBottom = ({ children }) => {
  return (
    <div className="absolute bottom-0 w-full flex flex-row justify-center items-center gap-4 pb-4 px-4 backdrop-blur-md bg-transparent-primary bg-opacity-80 ">
      {children}
    </div>
  );
};

export default RaindropPinnedToBottom;
